export default function getAttributeName(attributeId: string) {
  if (attributeId.includes("numerics.")) return attributeId.split("numerics.")[1];
  return attributeId.includes("attributes.") ? attributeId.split("attributes.")[1] : attributeId;
}
